import { EventDialog } from "./EventDialog";
import { TextInput, useRefresh } from "react-admin";
import { useCreateSubmit } from "../../../forms";

type CustomEventDialogProps = {
	closeDialog: () => void;
};

export const CustomEventDialog = (props: CustomEventDialogProps) => {
	const refresh = useRefresh();

	const saveCreate = useCreateSubmit(
		"mission-events",
		"Mission event created",
		{
			resource: "missions",
			idColumn: "mission_id",
			view: "show",
		},
		() => {
			refresh();
			props.closeDialog();
		}
	);

	return (
		<EventDialog {...props} title="Custom Event" onSubmit={saveCreate}>
			<TextInput source="name" fullWidth />
		</EventDialog>
	);
};
